var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHardBevWrapUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "28 0 80 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5411_2094)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.8301 12.8577L59.8301 19.7859C59.554 20.2642 58.9424 20.428 58.4641 20.1519C57.9858 19.8757 57.8219 19.2642 58.0981 18.7859L62.0981 11.8577C62.3742 11.3794 62.9858 11.2155 63.4641 11.4916C63.9424 11.7678 64.1063 12.3794 63.8301 12.8577ZM65.4641 8.02753C63.0726 6.64682 60.0147 7.46619 58.634 9.85766L54.634 16.7859C53.2533 19.1773 54.0726 22.2353 56.4641 23.616C58.8556 24.9967 61.9135 24.1773 63.2942 21.7859L67.2942 14.8577C68.6749 12.4662 67.8556 9.40824 65.4641 8.02753Z",
    fill: "#f6e003",
    stroke: "#1D1D1D",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.5,
    y: 15.8936,
    width: 31,
    height: 4,
    rx: 2,
    fill: "#f6e003",
    stroke: "#1D1D1D",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 89.8936H69.5V90.8936C69.5 92.5504 68.1569 93.8936 66.5 93.8936H41.5C39.8431 93.8936 38.5 92.5504 38.5 90.8936V89.8936Z",
    fill: "#f6e003",
    stroke: "#1D1D1D",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.5,
    y: 19.8936,
    width: 37,
    height: 70,
    rx: 5,
    fill: "#f6e003",
    stroke: "#1D1D1D",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.5,
    y1: 24.3936,
    x2: 72.5,
    y2: 24.3936,
    stroke: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5003 75.1859C35.5003 75.1859 36.0859 56.686 54.2933 56.6862C72.5007 56.6864 72.5005 38.1862 72.5005 38.1862",
    stroke: "#1D1D1D",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9566 12.4978L30.8698 12.2634L30.9566 12.4978L30.9569 12.4977C30.9568 12.4977 30.9567 12.4978 30.9566 12.4978ZM30.7034 13.4334L31.0644 12.4579L32.0399 12.0969C32.6929 11.8553 32.6929 10.9318 32.0399 10.6902L31.0644 10.3292L30.7034 9.35366C30.4618 8.7007 29.5382 8.7007 29.2966 9.35366L28.9356 10.3292L27.9601 10.6902C27.3071 10.9318 27.3071 11.8553 27.9601 12.0969L28.9356 12.4579L29.2966 13.4334C29.5382 14.0864 30.4618 14.0864 30.7034 13.4334ZM31.1043 10.437L31.1042 10.4367L31.1043 10.437Z",
    fill: "#f6e003",
    stroke: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9566 6.49781L73.8698 6.26335L73.9566 6.49781L73.9569 6.4977C73.9568 6.49774 73.9567 6.49778 73.9566 6.49781ZM73.7034 7.43345L74.0644 6.45792L75.0399 6.09694C75.6929 5.85532 75.6929 4.93178 75.0399 4.69017L74.0644 4.32919L73.7034 3.35366C73.4618 2.7007 72.5382 2.7007 72.2966 3.35366L71.9356 4.32919L70.9601 4.69017C70.3071 4.93178 70.3071 5.85533 70.9601 6.09694L71.9356 6.45792L72.2966 7.43345C72.5382 8.08641 73.4618 8.08641 73.7034 7.43345ZM74.1043 4.437L74.1042 4.43672L74.1043 4.437Z",
    fill: "#f6e003",
    stroke: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7034 3.35366C42.4618 2.7007 41.5382 2.70069 41.2966 3.35366L40.6655 5.0591L38.9601 5.69017C38.3071 5.93178 38.3071 6.85532 38.9601 7.09694L40.6655 7.72801L41.2966 9.43345C41.5382 10.0864 42.4618 10.0864 42.7034 9.43345L43.3345 7.72801L45.0399 7.09694C45.6929 6.85533 45.6929 5.93179 45.0399 5.69017L43.3345 5.0591L42.7034 3.35366ZM43.2266 5.0192C43.2268 5.01925 43.2269 5.01929 43.227 5.01933L43.2266 5.0192Z",
    fill: "#f6e003",
    stroke: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.59 21.9836L81.3556 21.8968C81.3556 21.8967 81.3556 21.8966 81.3557 21.8965L81.3556 21.8968L81.59 21.9836ZM81.59 21.9836L81.5033 21.7491C81.5032 21.7492 81.5031 21.7492 81.503 21.7492L81.5033 21.7491L81.59 21.9836ZM83.7034 19.3537C83.4618 18.7007 82.5382 18.7007 82.2966 19.3537L81.3955 21.789L78.9601 22.6902C78.3071 22.9318 78.3071 23.8553 78.9601 24.0969L81.3955 24.9981L82.2966 27.4334C82.5382 28.0864 83.4618 28.0864 83.7034 27.4334L84.6045 24.9981L87.0399 24.0969C87.6929 23.8553 87.6929 22.9318 87.0399 22.6902L84.6045 21.789L83.7034 19.3537ZM81.3556 24.8903L81.3557 24.8906L81.3556 24.8903ZM84.4967 21.7491C84.4969 21.7492 84.497 21.7492 84.4971 21.7492L84.4967 21.7491Z",
    fill: "#f6e003",
    stroke: "#1D1D1D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5411_2094"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 107,
    height: 107,
    fill: "white",
    transform: "translate(0.5 0.893555)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHardBevWrapUp);
export default __webpack_public_path__ + "static/media/HardBevWrapUp.e60f7f99516ab011ef977bae00e8b26a.svg";
export { ForwardRef as ReactComponent };